import MyContainer from "@/components/MyContainer";
import { SaveButton } from "@/components/ui/buttons/save-button";
import MessageTemplateForm from "@/pages/message-template/form/message-template-form";
import { Box } from "@mui/material";
import { useState } from "react";
import MessageTemplateEditor from "./components/MessageTemplateEditor";

export function CreateMessageTemplate() {
  const [formHandlers, setFormHandlers] = useState<{
    handleSubmit: () => void;
    isSubmitting: boolean;
  } | null>(null);

  return (
    <MyContainer
      title="Create Message Templates"
      subtitle="Create, preview and test message templates"
      actions={
        formHandlers ? (
          <SaveButton
            disabled={formHandlers.isSubmitting}
            handleSave={formHandlers.handleSubmit}
          />
        ) : undefined
      }
      footer={
        formHandlers ? (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <SaveButton
              disabled={formHandlers.isSubmitting}
              handleSave={formHandlers.handleSubmit}
            />
          </Box>
        ) : undefined
      }
    >
      <MessageTemplateEditor
        initial={{
          templateCode: "ORDER_CONFIRMATION",
          title: "Order #{{order_number}}",
          content: "Hi {{customer_name}}\n[[postback:Confirm|CONFIRM_ORDER]]",
        }}
        params={{
          customer_name: "Engleang Sam",
          order_number: "ORD-999",
          view_order_link: "https://yourapp.com/orders/ORD-999",
        }}
        onSave={(tpl) => {
          // save to Postgres
          console.log("SAVE", tpl);
        }}
        onPostback={(payload) => {
          // call your backend -> send message / do action
          console.log("POSTBACK", payload);
        }}
      />

      {/* <MessageTemplateForm
        mode="create"
        onFormReady={(handlers) => setFormHandlers(handlers)}
      /> */}
    </MyContainer>
  );
}
